import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Wrench } from "lucide-react";

const HEX = { rosu: "#EF4444", galben: "#FDE047", albastru: "#3B82F6", verde: "#10B981", gri: "#6B7280", mov: "#A855F7" };
const LBL = { rosu: "roșii", galben: "galbene", albastru: "albastre", verde: "verzi", gri: "gri", mov: "mov" };
const fmtRo = (iso) => (iso ? iso.split("-").reverse().join("/") : "—");

// Istoric seturi de scule pentru o persoană / dubă / șantier.
export const ToolSetsHistorySection = ({ person_id, car_id, project_id, regie_id, title, compact }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    const params = {};
    if (person_id) params.person_id = person_id;
    else if (car_id) params.car_id = car_id;
    else if (project_id) params.project_id = project_id;
    else if (regie_id) params.regie_id = regie_id;
    else return;
    api.get("/tool-sets/history-by", { params }).then((r) => setItems(r.data?.items || [])).catch(() => setItems([]));
  }, [person_id, car_id, project_id, regie_id]);

  if (items === null) return null;
  if (items.length === 0) {
    if (compact) return null;
    return (
      <div className="card-flat p-3 mt-3 text-xs text-zinc-400" data-testid="tool-sets-history">
        <Wrench size={12} className="inline mr-1" /> {title || "🧰 Istoric scule"} — nicio alocare de set înregistrată.
      </div>
    );
  }
  return (
    <div className={`card-flat p-3 ${compact ? "mt-2" : "mt-3"}`} data-testid="tool-sets-history">
      <div className="text-[11px] uppercase tracking-wider font-bold text-zinc-600 mb-2 flex items-center gap-1.5">
        <Wrench size={12} /> {title || "🧰 Istoric scule"}
      </div>
      <div className="space-y-1 max-h-52 overflow-y-auto">
        {items.map((it, i) => (
          <div key={i} className="flex items-center justify-between gap-2 text-xs flex-wrap" data-testid={`tool-hist-row-${i}`}>
            <span className="inline-flex items-center gap-1.5 font-semibold">
              {(it.colors || []).map((c) => (
                <span key={c} className="w-3 h-3 rounded-full border border-white/70 shadow-sm inline-block" style={{ background: HEX[c] }} />
              ))}
              scule {(it.colors || []).map((c) => LBL[c] || c).join(" + ")}
              {!project_id && !regie_id && <span className="text-zinc-600 font-normal"> · {it.kind === "regie" || it.regie_id ? "🔁" : "📁"} {it.site}</span>}
            </span>
            <span className="text-zinc-500">
              {fmtRo(it.first_day)} → {fmtRo(it.last_day)} · {it.entries} {it.entries === 1 ? "alocare" : "alocări"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
